import styled from '@emotion/styled';
import {Subtitle} from '../../styles';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 142px;
  height: 142px;
`;

export const Label = styled(Subtitle)`
  position: absolute;
`;
